/**
 * CookieYes consent, with the same semantics as the PeopleXYZ app
 * (frontend/shared/hooks/use-cookie-consent.ts): no consent manager on the page
 * means no consent.
 */
type CkyConsent = { categories: Record<string, boolean> };

declare global {
  interface Window {
    getCkyConsent?: () => CkyConsent;
    revisitCkyConsent?: () => void;
  }
}

export function hasAnalyticsConsent(): boolean {
  if (typeof window === 'undefined' || typeof window.getCkyConsent !== 'function') return false;
  try {
    return window.getCkyConsent().categories.analytics === true;
  } catch {
    return false;
  }
}

export function onConsentChange(callback: () => void): () => void {
  document.addEventListener('cookieyes_banner_load', callback);
  document.addEventListener('cookieyes_consent_update', callback);
  return () => {
    document.removeEventListener('cookieyes_banner_load', callback);
    document.removeEventListener('cookieyes_consent_update', callback);
  };
}
